import { Component, ViewChild, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import { DialogComponent } from 'src/app/components';
import { LxmDialog } from 'src/app/_helpers';
import { asArray, Status } from 'src/app/enum';
import { ClientsService, IClientFormData } from 'src/app/_services/clients.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "add-contact-dialog",
  host: { 'class': 'dialog' },
  templateUrl: './add-contact.dialog.html'
})
export class AddContactDialogComponent implements OnInit {

  public saveLoading = false;
  public deleteLoading = false;

  public edit = false;

  public clientId: string;
  public formData: IClientFormData;
  public contact: any;

  public returnOnly = false; // Whether to return the dialog data or use inbuilt save/delete

  public statusOptions = asArray(Status);

  public translatedPortfolioDescription: string;

  @ViewChild('dialog', { static: true, read: DialogComponent })
  private _dialog: DialogComponent;

  public form = new FormGroup({
    id: new FormControl(),
    name: new FormControl(),
    role: new FormControl(),
    portfolioDescription: new FormControl(),
    email: new FormControl(),
    phoneNumberShort: new FormControl(),
    phoneCode: new FormControl(),
    status: new FormControl(Status.Active)
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) private _data: any,
    public dialogRef: MatDialogRef<AddContactDialogComponent>,
    private _lxmDialog: LxmDialog,
    private _clientsService: ClientsService,
    private _translateService: TranslateService
  ) {

    const { contact, edit, clientId, formData, returnOnly } = _data || {};

    this.edit = edit;
    this.formData = formData;
    this.clientId = clientId;
    this.contact = contact;
    this.returnOnly = returnOnly;

    if (!contact) {
      return;
    }

    this.form.patchValue({
      id: contact.id,
      name: contact.name,
      role: contact.role,
      portfolioDescription: contact.portfolioDescription,
      email: contact.email,
      phoneNumberShort: contact.phoneNumberShort,
      phoneCode: contact.phoneCode,
      status: contact.status
    });
  }

  public getTranslatedPortfolioDescription() {
    if (!this.contact) {
      return null;
    }

    const lang = this._translateService.currentLang;

    const { translatedPortfolioDescription, translatedPortfolioDescriptionLanguageOrder, portfolioDescription } = this.contact || {};

    if (translatedPortfolioDescription) {

      if (translatedPortfolioDescription[lang]) {
        return this.contact.translatedPortfolioDescription[lang];
      }

      for (const l of translatedPortfolioDescriptionLanguageOrder) {
        if (translatedPortfolioDescription[l]) {
          return translatedPortfolioDescription[l];
        }
      }
    }

    return portfolioDescription;
  }

  public get contactId() {
    return this.form.get('id').value;
  }

  public get phoneCode() {
    return this.form.get('phoneCode').value;
  }

  public get phoneNumberShort() {
    return this.form.get('phoneNumberShort').value;
  }

  public closeDialog(res = null) {
    this.dialogRef.close(res);
  }

  public deleteContact() {
    this._lxmDialog.confirm({
      title: 'cards.clients.contacts.dialog.delete.title',
      message: 'cards.clients.contacts.dialog.delete.message'
    }, () => {
      this.deleteLoading = true;
      this._clientsService.deleteContact(this.contactId, this.clientId)
        .result(null, res => {
          this.deleteLoading = false;
          this.closeDialog();
        }, e => {
          console.error(e);
          this.deleteLoading = false;
        })
    });

  }

  public save() {
    const f = this.form.value;

    let req = {
      id: this.returnOnly ? null : f.id,
      clientId: this.clientId,
      name: f.name,
      phoneCodeId: f.phoneCode?.id,
      phoneNumberShort: f.phoneNumberShort,
      email: f.email,
      role: f.role,
      portfolioDescription: f.portfolioDescription,
      status: f.status
    };

    let observable;
    if (this.returnOnly) {
      observable = this._clientsService.validateContact(req);
    } else {
      observable = this._clientsService.saveContact(req.id, req);
    }

    this.saveLoading = true;
    
    observable
      .result(this.form, res => {
        let contact = req;

        Object.assign(contact, {
          id: res.tenantUserId,
          userId: res.userId
        });

        this.closeDialog(contact);
        this.saveLoading = false;
      }, e => {
        this.saveLoading = false;
      });
  }

  ngOnInit() {
    this.translatedPortfolioDescription = this.getTranslatedPortfolioDescription();
  }
}

